import { Instance } from 'mobx-state-tree'
import { AnonymousUserModelBase } from './AnonymousUserModel.base'

/* The TypeScript type of an instance of AnonymousUserModel */
export interface AnonymousUserModelType extends Instance<typeof AnonymousUserModel.Type> {}

/* A graphql query fragment builders for AnonymousUserModel */
export {
  selectFromAnonymousUser,
  anonymousUserModelPrimitives,
  AnonymousUserModelSelector
} from './AnonymousUserModel.base'

/**
 * AnonymousUserModel
 */
export const AnonymousUserModel = AnonymousUserModelBase.actions((self) => ({
  // This is an auto-generated example action.
  log() {
    console.log(JSON.stringify(self))
  }
}))
